import { Box } from '@mui/material';
import backgroundImage from '../assets/images/background.png';
import LoginForm from '../components/forms/loginForm';

const Login = () => {
    return (
        <Box
            sx={{
                minHeight: '100vh',
                backgroundImage: `url(${backgroundImage})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: 'white',
            }}
        >
            <LoginForm />
        </Box>
    );
}

export default Login;